import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
const { isRP } = getProjectConditions()

export const getPaymentMethodAccess = (key, paymentMethods) => {
  if(!key && !paymentMethods.length) return ''
  return isRP ? paymentMethods?.payment_account_permissions?.includes(key) : true
}
